module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "more",
    class: {
      more_cancel: _vm.cancel
    },
    on: {
      "click": function($event) {
        return _vm.$emit(_vm.action)
      }
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.btnText))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d78ab8c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/item/components/More.vue
// module id = dee97df16c48710b6624
// module chunks = 89